import {
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { AreasType } from "../../../../../domain/models/executive-summary/force-field-type";
import { useState } from "react";
import IMAGES from "../../../../../assets/images/images";
import FieldForceTableDetail from "./FieldForceTableDetail";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";

type Props = {
  data: AreasType[];
};

const ForceFieldTable: React.FC<Props> = ({ data }) => {
  const [opened, setOpened] = useState<boolean[]>(
    new Array<boolean>(data.length).fill(false)
  );
  const [openChannelPay, setOpenChannelPay] = useState<boolean>(false);
  const [openChannelPaisa, setOpenChannelPaisa] = useState<boolean>(false);

  const cellStyle = {
    border: "none",
    bgcolor: "#F9FAFD",
    color: "#687182",
    fontSize: "0.7rem",
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell padding="none" rowSpan={2} sx={cellStyle} />
              <TableCell
                padding="none"
                rowSpan={2}
                sx={{
                  ...cellStyle,
                  width: opened.find((a) => a === true) ? "5vw" : "11vw",
                }}
              >
                AREA
              </TableCell>
              {opened.find((a) => a === true) && (
                <TableCell
                  padding="none"
                  rowSpan={2}
                  sx={{ ...cellStyle, width: "6vw" }}
                >
                  HEADQUARTER
                </TableCell>
              )}
              <TableCell
                padding="none"
                align="center"
                colSpan={3}
                sx={{ ...cellStyle, minWidth: "10vw" }}
              >
                FIELD FORCE
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                colSpan={2}
                sx={cellStyle}
              >
                EFFECTIVENESS
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                colSpan={2}
                sx={cellStyle}
              >
                VISITS
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                colSpan={3}
                sx={{ ...cellStyle, bgcolor: "#E5F3FF", width: "10vw" }}
              >
                STOCKIST
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                colSpan={3}
                sx={{ ...cellStyle, bgcolor: "#F4E5CF" }}
              >
                <Stack
                  direction={"row"}
                  justifyContent={"space-around"}
                  alignItems={"center"}
                >
                  SEMI
                  <Stack direction={"row"}>
                    <img src={IMAGES.ChannelPaisa} alt="Channel Paisa" />
                    <IconButton
                      size="small"
                      onClick={() => setOpenChannelPaisa(!openChannelPaisa)}
                    >
                      {!openChannelPaisa ? (
                        <NavigateNextIcon
                          fontSize="small"
                          sx={{
                            bgcolor: "white",
                            borderRadius: "50%",
                            color: "#E68900",
                          }}
                        />
                      ) : (
                        <NavigateBeforeIcon
                          fontSize="small"
                          sx={{
                            bgcolor: "white",
                            borderRadius: "50%",
                            color: "#E68900",
                          }}
                        />
                      )}
                    </IconButton>
                  </Stack>
                </Stack>
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                colSpan={3}
                sx={{
                  ...cellStyle,
                  bgcolor: "#C6C7E5",
                  color: "white",
                }}
              >
                <Stack
                  direction={"row"}
                  justifyContent={"space-around"}
                  alignItems={"center"}
                >
                  RETAILER
                  <Stack direction={"row"}>
                    <img src={IMAGES.ChannelPay} alt="Channel Pay" />
                    <IconButton
                      size="small"
                      onClick={() => setOpenChannelPay(!openChannelPay)}
                    >
                      {!openChannelPay ? (
                        <NavigateNextIcon
                          fontSize="small"
                          sx={{
                            bgcolor: "white",
                            borderRadius: "50%",
                            color: "#E68900",
                          }}
                        />
                      ) : (
                        <NavigateBeforeIcon
                          fontSize="small"
                          sx={{
                            bgcolor: "white",
                            borderRadius: "50%",
                            color: "#E68900",
                          }}
                        />
                      )}
                    </IconButton>
                  </Stack>
                </Stack>
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                colSpan={3}
                sx={{ ...cellStyle, bgcolor: "#F2F9FF", width: "10vw" }}
              >
                CONTROL CHEMIST
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                colSpan={3}
                sx={{ ...cellStyle, bgcolor: "#E5F3FF", width: "10vw" }}
              >
                HCP
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell padding="none" align="center" sx={cellStyle}>
                WORK DAY
              </TableCell>
              <TableCell padding="none" align="center" sx={cellStyle}>
                COV
              </TableCell>
              <TableCell padding="none" align="center" sx={cellStyle}>
                CALL AVG
              </TableCell>
              <TableCell padding="none" align="center" sx={cellStyle}>
                TOUR PLAN
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                sx={{ ...cellStyle, width: "3vw" }}
              >
                DEV
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                sx={{ ...cellStyle, width: "3vw" }}
              >
                ABM
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                sx={{ ...cellStyle, width: "3vw" }}
              >
                RBM
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                sx={{ ...cellStyle, bgcolor: "#E5F3FF" }}
              >
                MET
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                sx={{ ...cellStyle, bgcolor: "#E5F3FF" }}
              >
                CALL
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                sx={{ ...cellStyle, bgcolor: "#E5F3FF" }}
              >
                COV
              </TableCell>
              {openChannelPaisa ? (
                <>
                  <TableCell
                    padding="none"
                    align="center"
                    sx={{ ...cellStyle, bgcolor: "#F4E5CF", width: "4vw" }}
                  >
                    INVOICES
                  </TableCell>
                  <TableCell
                    padding="none"
                    align="center"
                    sx={{ ...cellStyle, bgcolor: "#F4E5CF", width: "4vw" }}
                  >
                    ORDER
                  </TableCell>
                  <TableCell
                    padding="none"
                    align="center"
                    sx={{ ...cellStyle, bgcolor: "#F4E5CF", width: "4vw" }}
                  >
                    ACTIVE
                  </TableCell>
                </>
              ) : (
                <>
                  <TableCell
                    padding="none"
                    align="center"
                    sx={{ ...cellStyle, bgcolor: "#F4E5CF", width: "4vw" }}
                  >
                    MET
                  </TableCell>
                  <TableCell
                    padding="none"
                    align="center"
                    sx={{ ...cellStyle, bgcolor: "#F4E5CF", width: "4vw" }}
                  >
                    CALL
                  </TableCell>
                  <TableCell
                    padding="none"
                    align="center"
                    sx={{ ...cellStyle, bgcolor: "#F4E5CF", width: "4vw" }}
                  >
                    COV
                  </TableCell>
                </>
              )}
              {openChannelPay ? (
                <>
                  <TableCell
                    padding="none"
                    align="center"
                    sx={{
                      ...cellStyle,
                      bgcolor: "#C6C7E5",
                      color: "white",
                      width: "4.5vw",
                    }}
                  >
                    INVOICES
                  </TableCell>
                  <TableCell
                    padding="none"
                    align="center"
                    sx={{
                      ...cellStyle,
                      bgcolor: "#C6C7E5",
                      color: "white",
                      width: "4.5vw",
                    }}
                  >
                    ORDER
                  </TableCell>
                  <TableCell
                    padding="none"
                    align="center"
                    sx={{
                      ...cellStyle,
                      bgcolor: "#C6C7E5",
                      color: "white",
                      width: "4.5vw",
                    }}
                  >
                    ACTIVE
                  </TableCell>
                </>
              ) : (
                <>
                  <TableCell
                    padding="none"
                    align="center"
                    sx={{
                      ...cellStyle,
                      bgcolor: "#C6C7E5",
                      color: "white",
                      width: "4.5vw",
                    }}
                  >
                    MET
                  </TableCell>
                  <TableCell
                    padding="none"
                    align="center"
                    sx={{
                      ...cellStyle,
                      bgcolor: "#C6C7E5",
                      color: "white",
                      width: "4.5vw",
                    }}
                  >
                    CALL
                  </TableCell>
                  <TableCell
                    padding="none"
                    align="center"
                    sx={{
                      ...cellStyle,
                      bgcolor: "#C6C7E5",
                      color: "white",
                      width: "4.5vw",
                    }}
                  >
                    COV
                  </TableCell>
                </>
              )}
              <TableCell
                padding="none"
                align="center"
                sx={{ ...cellStyle, bgcolor: "#F2F9FF" }}
              >
                MET
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                sx={{ ...cellStyle, bgcolor: "#F2F9FF" }}
              >
                CALL
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                sx={{ ...cellStyle, bgcolor: "#F2F9FF" }}
              >
                COV
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                sx={{ ...cellStyle, bgcolor: "#E5F3FF" }}
              >
                MET
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                sx={{ ...cellStyle, bgcolor: "#E5F3FF" }}
              >
                CALL
              </TableCell>
              <TableCell
                padding="none"
                align="center"
                sx={{ ...cellStyle, bgcolor: "#E5F3FF" }}
              >
                COV
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <FieldForceTableDetail
                key={index}
                data={row}
                setOpened={setOpened}
                opened={opened}
                index={index}
                channelPay={openChannelPay}
                channelPaisa={openChannelPaisa}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ForceFieldTable;
